import React, { useState } from "react";
import { Link } from "react-router-dom";
import Alert from "@mui/material/Alert";
import { supabase } from "utils/supabase";
import enarmApexLogo from "assets/img/enarm-apex-logo.png";


export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [acceptedPrivacyPolicy, setAcceptedPrivacyPolicy] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");
    if (!name || !email || !password) {
      setErrorMessage("Por favor completa todos los campos.");
      return;
    }

    if (password.length < 6) {
      setErrorMessage("La contraseña debe tener al menos 6 caracteres.");
      return;
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      setErrorMessage("Ingresa un correo electrónico válido.");
      return;
    }

    if (name.length < 3) {
      setErrorMessage("El nombre debe tener al menos 3 caracteres.");
      return;
    }

    if (name.length > 50) {
      setErrorMessage("El nombre no puede tener más de 50 caracteres.");
      return;
    }

    if (!/^[a-zA-Z\s]+$/.test(name)) {
      setErrorMessage("El nombre solo puede contener letras y espacios.");
      return;
    }

    if (password.length > 50) {
      setErrorMessage("La contraseña no puede tener más de 50 caracteres.");
      return;
    }

    if (!acceptedPrivacyPolicy) {
      setErrorMessage("Debes aceptar la politica de privacidad para crear tu cuenta.");
      return;
    }

    const { error } = await supabase.auth.signUp({
      email: email,
      password: password,
      options: {
        data: {
          full_name: name
        },
        emailRedirectTo: `${window.location.origin}/auth/login`
      }
    });

    if(error) {
      if (error.message === "User already registered") {
        setErrorMessage("Este correo ya está registrado.");
      } else if (error.message === "Password should be at least 6 characters") {
        setErrorMessage("La contraseña debe tener al menos 6 caracteres.");
      } else if (error.message === "Unable to validate email address: invalid format") {
        setErrorMessage("Ingresa un correo electrónico válido.");
      } else {
        setErrorMessage("Ocurrió un error al crear tu cuenta. Por favor intenta de nuevo.");
      }
      return;
    }

    setName("");
    setEmail("");
    setPassword("");
    setAcceptedPrivacyPolicy(false);

    setSuccessMessage("Cuenta creada. Revisa tu correo para confirmar tu cuenta antes de iniciar sesión.");

  }

  return (
    <>
      <div className="container mx-auto px-4 h-full">
        <div className="flex content-start items-start justify-center h-full">
          <div className="w-full lg:w-6/12 px-4 -mt-20">
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0">
              <div className="rounded-t mb-0 px-6 py-6">
                <div className="text-center mb-3">
                  <img
                    src={enarmApexLogo}
                    alt="ENARM Apex Logo"
                    className="w-20 mx-auto"
                    style={{ width: "20rem" }}
                  />
                  <br />
                  <h6 className="text-blueGray-500 text-lg font-bold">
                    Registrate
                  </h6>
                </div>
              </div>
              <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                <form onSubmit={handleSubmit}>
                  {successMessage && (
                    <Alert severity="success" className="mb-4">
                      {successMessage}
                    </Alert>
                  )}

                  {errorMessage && (
                    <Alert severity="error" className="mb-4">
                      {errorMessage}
                    </Alert>
                  )}

                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Nombre
                    </label>
                    <input
                      type="text"
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="Nombre"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>

                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Email
                    </label>
                    <input
                      type="email"
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>

                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Contraseña
                    </label>
                    <div className="relative">
                      <input
                        id="grid-password"
                        type={showPassword ? "text" : "password"}
                        className="border-0 px-3 py-3 pr-10 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        placeholder="Contraseña"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      <button
                        type="button"
                        className="absolute flex items-center text-blueGray-400 hover:text-blueGray-600 focus:outline-none"
                        style={{ top: "50%", transform: "translateY(-50%)", right: "8px" }}
                        onClick={() => setShowPassword((prev) => !prev)}
                        aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                      >
                        {showPassword ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path d="M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A11.944 11.944 0 0019 10s-3-6-9-6a8.95 8.95 0 00-3.646.75L3.707 2.293zM7.5 8.086l3.414 3.414a2 2 0 01-3.414-3.414z" />
                            <path d="M10 6a4 4 0 014 4c0 .73-.196 1.415-.539 2.005l-1.507-1.507A2 2 0 0010.5 8.54L8.995 7.035A3.98 3.98 0 0110 6z" />
                            <path d="M5.256 6.67A11.96 11.96 0 001 10s3 6 9 6a8.93 8.93 0 004.216-1.016l-1.54-1.54A3.98 3.98 0 0110 14a4 4 0 01-4-4c0-.75.207-1.45.566-2.048l-1.31-1.31z" />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path d="M10 3C4 3 1 10 1 10s3 7 9 7 9-7 9-7-3-7-9-7zm0 11a4 4 0 110-8 4 4 0 010 8z" />
                            <path d="M10 8a2 2 0 100 4 2 2 0 000-4z" />
                          </svg>
                        )}
                      </button>
                    </div>
                  </div>

                  <div>
                    <label className="inline-flex items-center cursor-pointer">
                      <input
                        id="customCheckLogin"
                        type="checkbox"
                        className="form-checkbox border-0 rounded text-blueGray-700 ml-1 w-5 h-5 ease-linear transition-all duration-150"
                        checked={acceptedPrivacyPolicy}
                        onChange={(e) => setAcceptedPrivacyPolicy(e.target.checked)}
                      />
                      <span className="ml-2 text-sm font-semibold text-blueGray-600">
                        Acepto la{" "}
                        <Link to="/auth/politica-privacidad" className="text-lightBlue-500">
                          Politica de privacidad
                        </Link>
                      </span>
                    </label>
                  </div>

                  <div className="text-center mt-6">
                    <button
                      className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                      type="submit"
                    >
                      Crear cuenta
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
